webpackJsonp([48555284016869],{

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: "content-wrapper" },
	    _react2.default.createElement(
	      "div",
	      { className: "row" },
	      _react2.default.createElement(
	        "div",
	        { className: "columns" },
	        _react2.default.createElement(
	          "div",
	          { className: "popular-services-wrapper" },
	          _react2.default.createElement(
	            "h2",
	            { className: "base-caption base-caption--center base-caption--undefined" },
	            "\u041C\u043E\u0434\u0443\u043B\u0438"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "popular-services" },
	            data.allMarkdownRemark.edges.map(function (usluga, i) {
	              var frontmatterUsluga = usluga.node.frontmatter;
	
	              return _react2.default.createElement(
	                _gatsbyLink2.default,
	                { key: i, className: "usluga-card", to: frontmatterUsluga.path },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card-caption" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card-caption__img-wrapper" },
	                    _react2.default.createElement("img", { src: frontmatterUsluga.icon, alt: "icon" })
	                  ),
	                  _react2.default.createElement(
	                    "h4",
	                    { className: "card-caption__name" },
	                    frontmatterUsluga.title
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "usluga-card__links" },
	                  _react2.default.createElement(
	                    "p",
	                    { className: "usluga-card__link" },
	                    "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C",
	                    _react2.default.createElement("span", { className: "arrow__right" })
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-modules-js-47ee3a5c892bd74ef9d7.js